export default __webpack_public_path__ + "static/media/Get Started Image-15 (1).c6a37013.svg";